import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import moment from "moment";

export const findAllMina = createAsyncThunk(
  "Mina/FindAllMinaIssue",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Mina/FindAllMinaIssue`,
        formData
      );

      return response.data.Data;
    } catch (error: any) {
      console.error("Error Fetching Mina", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createMina = createAsyncThunk(
  "Mina/InsertMinaIssue",
  async (formdata: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Mina/InsertMinaIssue`,
        formdata
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Create Mina:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateMina = createAsyncThunk(
  "Mina/UpdateMinaIssue",
  async (formdata: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Mina/UpdateMinaIssue`,
        formdata
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Update Mina:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteMina = createAsyncThunk(
  "Mina/DeleteMinaIssue",
  async (ID: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Mina/DeleteMinaIssue`,
        { mina_issue_guid: ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Deleting Ghat:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getMinaById = createAsyncThunk(
  "Mina/FindByIDMinaIssue",
  async (ID: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Mina/FindByIDMinaIssue`,
        { mina_issue_guid: ID }
      );
      const result = response.data?.Data as any;
      return {
        id: result.id,
        mina_issue_guid: result.mina_issue_guid,
        mina_issue_no: result.mina_issue_no,
        issue_date: result.issue_date ? moment(result.issue_date).toDate() : "",
        approx_delivery_date: result.approx_delivery_date
          ? moment(result.approx_delivery_date).toDate()
          : "",
        karigar_id: result.karigar_id,
        karigar_name: result.karigar_name,
        karigar_nick_name: result.karigar_nick_name,
        address: result.address,
        mina_issue_order: result?.mina_issue_order,
        karigarIdWiseOutStandingAmount: result?.karigarIdWiseOutStandingAmount,
      } as any;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Mina:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteMinaOrderItems = createAsyncThunk(
  "Mina/DeleteMinaIssueOrder",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Mina/DeleteMinaIssueOrder`,
        { id: ID }
      );
      SuccessToast(response?.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Mina Order item:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateMinaImage = createAsyncThunk(
  "Mina/MinaIssueImageUpdate",
  async (formdata: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Mina/MinaIssueImageUpdate`,
        formdata
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Update Mina Image:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

